import React, {
 createContext, useState, useEffect, useMemo, 
} from 'react';
import PropTypes from 'prop-types';

export const Bookingcontext = createContext();

const Bookingcontextprovider = ({ children }) => { 
    const [count, setcount] = useState(0);
  
  const value = useMemo(() => ({ 
    count, setcount,
}), [count]);

  return (
    <Bookingcontext.Provider value={value}>
      {children}
    </Bookingcontext.Provider>
  );
};

Bookingcontextprovider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Bookingcontextprovider;

